'use client'
import MainLayout from '@/components/Layouts/Main'
import React, { useEffect, useRef, useState } from "react";
import HomeSection from '@/components/Sections/HomeSection/HomeSection';
import { home } from '@/helpers/content/id/home';
import Faq from '@/components/Faq/Faq';
import { faqTax } from '@/helpers/content/id/services/tax/faq';
import CallToAction from '@/components/CallToAction/CallToAction';
import TaxServices from '@/components/PageServices/Tax/TaxServices';
import MiniCard from '@/components/MiniCard/MiniCard'
import Image from "next/image"
import { homeFinops } from '@/helpers/content/id/services/financial-operational/homeFinops';
import ServicesFinOps from '@/components/Sections/FinOps/ServicesFinOps';
import { faqFinOps } from '@/helpers/content/id/services/financial-operational/faq';
import { listReasonsFinOps } from '@/helpers/content/id/services/financial-operational/reasons';
import HomeSectionReconciliation from '@/components/HomeSectionReconciliation/HomeSectionReconciliation';
import { listReasonsReconciliation } from '@/helpers/content/id/services/reconciliation-automation/reasons';
import Feature from '@/components/PageServices/Freya/Feature';
import DetailedRecon from '@/components/PageServices/Freya/DetailedRecon';
import HowToWork from '@/components/PageServices/Freya/HowToWork';
import StudyCase from '@/components/PageServices/Freya/StudyCase';
import { faqReconciliation } from '@/helpers/content/id/services/reconciliation-automation/faq';
import { useRouter } from 'next/router';
import { reconContact } from '@/helpers/content/id/services/reconciliation-automation/contact';
import * as ga from "@/libs/analytics";
import { useTranslation } from 'react-i18next';
import Reasons from '@/components/PageServices/Freya/Reasons';

export default function ReconciliationAutomation() {
  const [isShowBar, setisShowBar] = useState(false)
  const { t } = useTranslation();
  const homeRef = useRef()
  const pricingRef = useRef()
  const servicesRef = useRef()
  const servicesMobileRef = useRef([])
  const servicesMainMobileRef = useRef()
  const contactRef = useRef()
  const clientRef = useRef()
  const [nextTab, setnextTab] = useState(0)
  const [nextTabMobile, setnextTabMobile] = useState(0)
  const [servicesElementScroll, setservicesElementScroll] = useState(0)

  const router = useRouter()

  useEffect(() => {
    const head = document.head;
    const script = document.createElement("script");
    script.innerHTML = `
      setTimeout(function(){var a=document.createElement("script");
      var b=document.getElementsByTagName("script")[0];
      a.src=document.location.protocol+"//script.crazyegg.com/pages/scripts/0055/6070.js?"+Math.floor(new Date().getTime()/3600000);
      a.async=true;a.type="text/javascript";b.parentNode.insertBefore(a,b)}, 1);
    `;
    head.appendChild(script);
    const handleRouteChange = (url) => {
      ga.pageview(url);
    };
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);

  useEffect(() => {
    const getLocalStorage = JSON.parse(localStorage.getItem("type"))
    if (getLocalStorage) {
      console.log("local storage",getLocalStorage)
      if (getLocalStorage.index) {
        if (getLocalStorage.scrollTo == "services") {
          setnextTab(getLocalStorage.index)
        }else if(getLocalStorage.scrollTo == "services-mobile"){
          setnextTabMobile(getLocalStorage.index)
        }
        moveToSection(getLocalStorage.scrollTo, getLocalStorage.index)
      }else{
        moveToSection(getLocalStorage.scrollTo)
      }
    }
    localStorage.removeItem("type")
  }, [])
  

  const moveToSection = (type, index = 0) => {
    if (type == "pricingRef") {
      window.scrollTo({top: pricingRef.current.offsetTop, behavior:"smooth" })
    }else if(type == "client"){
      setisShowBar(false)
      window.location.href = "/"
      localStorage.setItem("type",JSON.stringify({scrollTo:"client"}))
    }else if (type == "services") {
      setisShowBar(false)
      // setnextTab(index)
      window.scrollTo({
        top: servicesRef.current.offsetTop, 
        behavior:"smooth"
      })
    }
    else if (type == "services-mobile") {
      console.log(index)
      setservicesElementScroll(prev => prev > 0 ? prev : servicesMainMobileRef.current.getBoundingClientRect().top - 100)
      setisShowBar(false)
      setnextTabMobile(index)
      // setTimeout(() => {
      //   window.scrollTo({
      //     top: servicesMainMobileRef.current.getBoundingClientRect().top,
      //     bottom: servicesMainMobileRef.current.getBoundingClientRect().bottom,
      //     behavior:"smooth"
      //   })
      // }, 100);
    }
    else if(type == "article"){
      window.open("https://blog.ledgerowl.com/","_blank")
    }else if(type == "home") { 
      window.scrollTo({
        top: homeRef.current.offsetTop,
        behavior:"smooth"
      })
    }else if(type == "contact") { 
      window.scrollTo({
        top: contactRef.current.offsetTop,
        behavior:"smooth"
      })
    }else if(type == "consultation"){
      window.scrollTo({
        top: contactRef.current.offsetTop,
        behavior:"smooth"
      })
      // window.open("https://api.whatsapp.com/send?phone=6281287889023&text=%20%20Hi!%20Can%20I%20ask%20more%20on%20ledgerowl%20services%20%3f","_blank")
    }
  }
  return (
    <MainLayout
      setnextTab={setnextTab}
      setnextTabMobile={setnextTabMobile}
      setisShowBar={setisShowBar}
      isShowBar={isShowBar}
      moveToSection={moveToSection}
      textWa={t("floating_message_service_recon")} 
    >
      <HomeSectionReconciliation moveToSection={moveToSection} homeRef={homeRef} />
      <div className='relative flex max-w-[1280px] lg:mx-auto lg:container flex-col w-full px-4 py-16 lg:px-8 lg:py-[100px] bg-base-white'>
        <Reasons list={listReasonsReconciliation}/>
      </div>
      <Feature />
      <DetailedRecon />
      <HowToWork/>
      <StudyCase />
      <Faq faq={faqReconciliation}/>
      <CallToAction contact={reconContact} service={"Rekonsiliasi Otomatis"} contactRef={contactRef} textWa={t("floating_message_service_recon")}  />
    </MainLayout>
  )
}
